import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";
import drabhi from "../assets/drabhishek.jpg";
import drnamita from "../assets/drnamita.jpg";
import banner from "../assets/4.jpg";

const team = [
  {
    name: "Dr. Abhishek Kavlekar (M.D.S)",
    role: "Prosthodontist & Implantologist",
    image: drabhi,
  },
  {
    name: "Dr. Namita Kavlekar (M.D.S)",
    role: "Prosthodontist & Microscopic Dentistry",
    image: drnamita
  },
];

export default function OurTeamPage() {
  return (
    <PageTransition testId="our-team-page">
      <PageHero
        title="Our Team"
        subtitle="A collaborative team dedicated to excellence in treatment, comfort, and patient trust."
        image={banner}
        testId="our-team-page-hero"
      />

      <div className="mx-auto max-w-5xl px-6 py-12 md:px-10 md:py-16">
  <AnimatedSection testId="our-team-grid-section">
    
    <div className="grid gap-6 md:grid-cols-2">
      
      {team.slice(0, 2).map((member) => (
        <article
          key={member.name}
          className="group overflow-hidden rounded-2xl border border-[#f2e6c9] bg-white transition-all duration-300 hover:shadow-lg"
        >
          
          {/* ✅ IMAGE (natural height) */}
          <div className="bg-[#f9f6ef]">
            <img
              src={member.image}
              alt={member.name}
              className="w-full h-auto object-contain"
              loading="lazy"
            />
          </div>

          {/* TEXT */}
          <div className="p-4 text-center">
            <h2 className="font-[Playfair_Display] text-xl text-[#1a1a1a]">
              {member.name}
            </h2>

            <p className="mt-1 font-[Manrope] text-sm text-[#777]">
              {member.role}
            </p>
          </div>

        </article>
      ))}

    </div>

  </AnimatedSection>
</div>
    </PageTransition>
  );
}
